import request from '@/fetch/index'

// 获取用户登录后的信息  法人
export function getUserInfoTicket () {
  return request({
    url: '/api/loan/user/info',
    method: 'POST'
  })
}

// 获取用户登录后的信息  个人
export function getUserInfoToken () {
  return request({
    url: '/api/loan/user/get-personal-info',
    method: 'GET'
  })
}

/**
 * 判断是否在个人黑名单内
 * @param {*} { cardId - 申请人身份证号, name - 申请人姓名 }
 */
export function getUserDishonestyInfo ({ cardId, name }) {
  return request({
    url: '/api/loan/information/judgeDishonesty',
    method: 'GET',
    params: {
      cardId,
      name
    }
  })
}

/**
   * 使用企业名称 获取 统一社会性用代码
   * @param {*} { name }
   */
export function getUniscidByName ({ name }) {
  return request({
    url: '/api/loan/information/enterprise',
    method: 'GET',
    params: {
      name
    }
  })
}

/**
   * 获取企业关联关系
   * @param {*} { cardNo - 身份证号 ， uniscid - 企业统一社会信用代码}
   */
export function getUserRelationship ({ cardNo, uniscid }) {
  return request({
    url: '/api/loan/information/relationship',
    method: 'GET',
    params: {
      cardNo,
      uniscid
    }
  })
}

/**
 * 查询企业地址等信息
 * @param {enterpriseName} 企业名称
 */
export function getEnterpriseAddressInfo ({ enterpriseName }) {
  return request({
    url: '/api/loan/company/enterpriseAddressInfo',
    params: {
      enterpriseName
    }
  })
}

/**
 * 获取token
 */
export function getToken () {
  return request({
    url: '/api/loan/company/getInfoToken',
    method: 'GET'
  })
}

const logoutUrl = {
  demo: 'https://waftest.zjfcs.org.cn',
  dev: 'https://waftest.zjfcs.org.cn',
  test: 'https://waftest.zjfcs.org.cn',
  pre: 'https://loanh5.zjfcs.org.cn',
  qProd: 'http://223.4.64.21:3008',
  prod: 'https://loanh5.zjfcs.org.cn',
  testMicroApp: 'https://waftest.zjfcs.org.cn',
  prodMicroApp: 'https://loanh5.zjfcs.org.cn'
}
const logoutPath = logoutUrl[process.env.VUE_APP_ENV]

/**
 * 退出登录
 */
export function logout () {
  return request({
    url: `${logoutPath}/api/sso/user/corporation/logout`,
    method: 'POST'
  })
}
/**
 * 退出登录
 */
export function unifiedLogout() {
  return request({
    url: 'https://portal.zjzwfw.gov.cn/uc/unifiedLogout',
    method: 'GET'
  })
}
/**
 * 个人退出
 * @returns
 */
export function ucLogout() {
  return request.jsonp('https://portal.zjzwfw.gov.cn/uc/logout')
}
